import _ from "underscore";
import Marionette from "marionette";
import $ from "jquery";
import App from "app";
import template from "./templates/sidebar.html";

var SidebarViewBase = Marionette.LayoutView.extend({
    template: _.template(template),

    regions: {
        editors: ".editors",
        exceptions: ".exception-items",
        modal: "#loading-modal"
    },

    ui: {
        editors: ".editors",
        previewButton: ".preview-button",
        metadataButton: ".metadata-modal-button",
        exceptionsContainer: ".exceptions-container",
        exceptionsClear: "#clearBtn"
    },

    onSidebarResize: function(extraOffset) {
        var exceptionContainer = this.$el.find("div.exceptions-container");
        var actionsBar = this.$el.find("div.actions");

        if (this.$el.find(".exception-message").hasClass("expanded")) {
            exceptionContainer.css({ "max-height": "450px", overflow: "auto" });
        } else {
            exceptionContainer.css({ "max-height": "unset", overflow: "unset" });
        }

        this.$el.find("div.editors>div>ul.controls").css("height", "100%");
    },

    initSideBarResizer: function() {
        var _this = this;

        // the editors containers height has to be calculated in javascript

        setTimeout(function() {
            _this.onSidebarResize();
        }, 100);
        $(window).resize(function() {
            _this.onSidebarResize();
        });
        this.listenTo(App.vent, "app:errors:exceptions-container:resized", function() {
            _this.onSidebarResize();
        });
    }
});

export default SidebarViewBase;

// Temporary solution for [DEV-41432]
const sidebarExceptionHeightOffset = -30;
